const MetadataCode = {
  USER_NOT_EXISTS_ON_THIS_ORG: "8004",
  SYMPTOM_NOT_FOUND: "8018",
  RESET_TOKEN_NOT_EXISTS: "2001",
  EMAIL_IS_NOT_FOUND: "2001",
};

export default Object.freeze(MetadataCode);
